module.exports = __webpack_public_path__ + "static/media/special_1.98d772a8.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/special/special_1.csv
// module id = 737
// module chunks = 0